import React, { useState } from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { Grid, Box, CircularProgress, Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import currentUserSelector from '../../../selectors/currentUserSelector';
import { showErrorSnackbar,showSuccessSnackbar } from '../../../actions/snackbar';

export default function CheckoutForm( {onPaymentMethodId,onCardDetails }) {
  const stripe = useStripe();
  const elements = useElements();
  const currentUser = useSelector(currentUserSelector);
  const [paymentMethodId,setPaymentMethodId] = useState('');
  const dispatch = useDispatch();
  const [show,setShow]=useState(true);

  console.log("user",currentUser?.email)
  const handleSubmit = (event) => {
    setShow(false);
    event.preventDefault();
    stripe
      .createPaymentMethod({
        type: 'card',
        card: elements.getElement(CardElement),
        billing_details: { email: currentUser?.email }
      })
      .then((result) => {
        const { error, paymentMethod } = result;

        if (!error) {
          const { id, card } = paymentMethod;
console.log("details fetched",id,card)
setPaymentMethodId(id)
onPaymentMethodId(id)
onCardDetails(card)
          dispatch(showSuccessSnackbar('Click on Confirm to Confirm your subscription!'));
        //   dispatch(
        //     confirmPaymentMethod({
        //       payment_method_id: id,
        //       user_email: 'testuser@gmail.com',
        //       card_no: card.last4,
        //       card_expire: `${card.exp_month.toString().padStart(2, '0')}/${card.exp_year}`,
        //       card_type: card.brand
        //     })
        //   ).then((res) => handleServerResponse(res, card));
          return;
        }
        else{
            console.log("error is",error)
        }
        
        dispatch(showErrorSnackbar('Request Failed ! Please provide correct information!'));
        setShow(true);
      });
  };


  return (
    <>
    <form onSubmit={handleSubmit} style ={{textAlign:"center", padding:20}}>
          <Grid container spacing={3}>
            
            <Grid item md={12} style={{margin:'auto'}}>
              <div>
                <CardElement options={{hidePostalCode:true}} />
              </div>
              <Box fontSize={16} p={2} pb={1} display="flex" justifyContent="space-between">
                <Box fontWeight={600} mr={3}>
                  {'Billing Email'}
                </Box>
                <Box color="#555">{currentUser?.email}</Box>
              </Box>
              {show?
              <button type='submit'>Add</button>
              :null}
            </Grid>
          </Grid>
        </form>
    </>
  );
}
